import { RequirementExpirationStrategy } from "@wingspanhq/wingspan-api-sdk";

export const getExpirationLabel = (
  strategy?: RequirementExpirationStrategy,
  days?: number
): string => {
  if (!strategy || strategy === RequirementExpirationStrategy.NONE) {
    return "No expiration";
  }

  switch (strategy) {
    case RequirementExpirationStrategy.DAYS_AFTER_COMPLETE:
      return `${days ?? 0} days after completion`;
    case RequirementExpirationStrategy.DAYS_AFTER_YEAR_START:
      return `${days ?? 0} days after year start`;
    case RequirementExpirationStrategy.DAYS_BEFORE_YEAR_END:
      return `${days ?? 0} days before year end`;
    default:
      return "Custom expiration";
  }
};
